import { AiMessageRoleEnum } from 'graphql-common';

type ToolActivityCandidate = {
  role: AiMessageRoleEnum;
  content?: string | null;
  toolCalls?: { id: string }[] | null;
};

// A tool-activity transcript row: an assistant message with no answer text but
// one or more tool invocations (datizy-api/docs/fe/ai_frontend_guide.md §5). Rendered as
// an activity row, not a chat bubble, and excluded from "last answer" lookups.
export default function isAiToolActivityMessage(
  message: ToolActivityCandidate,
): boolean {
  return (
    message.role === AiMessageRoleEnum.Assistant &&
    !message.content &&
    (message.toolCalls?.length ?? 0) > 0
  );
}
